<template>
  <div>
    <PageHeader :key="globalLanguage" :items="items" />
    <validation-observer ref="simpleRules">
      <div class="card">
        <div class="card-body">
          <b-row>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <validation-provider
                #default="{ errors }"
                name="subject"
                rules="required"
              >
                <TextInput
                  v-model="form.subject"
                  :label="$t('subject')"
                  :tooltipMessage="$t('subject')"
                  :required="true"
                  :error="errors[0]"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <validation-provider
                #default="{ errors }"
                name="Status"
                rules="required"
              >
                <label class="input-label form-label"
                  >{{ $t("status") }}&nbsp;<span style="color: red">*</span>
                </label>
                <MultiSelectInput
                  style="z-index: 9999"
                  v-model="form.active"
                  :key="form.active"
                  :options="statusOptions"
                  :multiple="false"
                  label="name"
                  trackBy="value"
                  :required="true"
                  placeholder="selectOption"
                  :error="errors[0]"
                >
                </MultiSelectInput>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12">
              <validation-provider
                #default="{ errors }"
                name="Body"
                rules="required"
              >
                <quill-editor
                  v-model="form.body"
                  :label="$t('body')"
                  required
                />
                <!-- <QuillEditor v-model="form.body" label="Body" required /> -->
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
          </b-row>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-end gap-2">
        <router-link
          to="/mail-templates"
          class="d-flex align-items-center gap-1 btn btn-secondary"
        >
          <feather-icon icon="XIcon" size="12" />
          <span>{{ $t("cancel") }}</span>
        </router-link>
        <b-button
          variant="primary"
          @click="store"
          class="d-flex align-items-center gap-1"
          v-if="$can(`${$route.meta.permission}.create`)"
          :disabled="isFormInvalid"
        >
          <feather-icon icon="PlusIcon" size="12" />
          <span>{{ $t("saveAndProceed") }}</span>
        </b-button>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import TextInput from "@/components/TextInput.vue";
import TextAreaInput from "@/components/TextareaInput.vue";
import LoadingButton from "@/components/LoadingButton.vue";
import PageHeader from "@/components/PageHeader.vue";
import { mapGetters } from "vuex";
import { getEditorContentLength } from "@/utils/helpers";
import { required, email } from "@validations";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import MultiSelectInput from "@/components/MultiSelectInput.vue";
import QuillEditor from "@/components/QuillEditor.vue";
export default {
  computed: {
    ...mapGetters(["errors", "isLoading"]),
    items() {
      return [
        {
          text: "Dental Twin",
          to: "/home",
        },
        {
          text: this.$t("settings"),
          to: "/settings",
        },
        {
          text: this.$t("mailTemplates"),
          to: "/mail-templates",
        },
        {
          text: this.$t("create"),
          active: true,
        },
      ];
    },
    isFormInvalid() {
      return !this.form.subject || !this.form.active || !this.form.body;
    },
    statusOptions() {
      return [
        {
          name: this.$t("active"),
          value: 1,
        },
        {
          name: this.$t("inactive"),
          value: 0,
        },
      ];
    },
  },
  components: {
    LoadingButton,
    TextInput,
    MultiSelectInput,
    TextAreaInput,
    PageHeader,
    ValidationProvider,
    ValidationObserver,
    QuillEditor,
  },
  remember: "form",
  data() {
    return {
      parsedHtml: "",
      form: {
        subject: "",
        active: null,
        body: "",
      },
    };
  },
  created() {
    this.form.active = this.statusOptions[0];
  },
  methods: {
    async store() {

      this.$refs.simpleRules.validate().then(async (success) => {
        if (success) {
          try {
            const length = getEditorContentLength(this.form.body);
            if (length === 0) this.form.body = "";

            this.$store.commit("isLoading", true);
            await this.$store.dispatch("mailTemplates/create", {
              ...this.form,
              active: this.form.active.value,
              body: this.form.body,
            });

            await this.$store.dispatch("mailTemplates/list");
            this.$router.push("/mail-templates");
          } catch (e) {
            console.error(e);
          } finally {
            this.$store.commit("isLoading", false);
          }
        }
      });
    },
  },
};
</script>
